<template>
	<div style="position: relative">
		<v-icon
			v-if="isGboAdmin()"
			flat
			dark
			@click="toggleTopMenu"
			class="material-icons-outlined text--white admin-top-menu-toggle"
			v-ripple="false"
			title="Hide top menu"
		>
			{{ $store.getters.topAdminMenuShown ? "keyboard_arrow_up" : "keyboard_arrow_down" }}
		</v-icon>
		<div
			:class="[productEditingState ? 'disable' : '' , 'top-menu-admin', 'admin-page-font']"
			:style="{'display': $store.getters.topAdminMenuShown ? 'block' : 'none'}">
			<v-toolbar fixed class="admin-menu" ref="adminToolBar" style="background-color: #003355; z-index: 100;">
				<v-toolbar-title class="admin-logo">
					<template v-if="betaMode">
						<v-btn style="margin: 0"
									 icon
									 v-if="showAdminMenu"
									 @click="toggleNavBar"
						>
							<v-icon class="admin-drop-down-arrow">menu</v-icon>
						</v-btn>
					</template>
					<template v-else>
						<v-menu bottom left content-class="admin-dropdown" v-if="showAdminMenu">
							<v-btn style="margin: 0"
										 slot="activator" icon
							>
								<v-icon class="admin-drop-down-arrow">menu</v-icon>
							</v-btn>

							<v-list v-if="useOverwrittenMenu">
								<v-list-tile v-for="(menuItem, i) in overwrittenMenu" :key="i">
									<v-list-tile-title>
										<router-link :to="menuItem.url">
											{{ menuItem.title }}
										</router-link>
									</v-list-tile-title>
								</v-list-tile>
							</v-list>
							<v-list v-else>
								<v-list-tile v-for="(menuItem, i) in menu" :key="i">
									<v-list-tile-title>
										<router-link :to="menuItem.url">
											{{ menuItem.title }}
										</router-link>
									</v-list-tile-title>
								</v-list-tile>
							</v-list>
						</v-menu>
					</template>

					<!-- <v-menu bottom left :offset-y="offset" content-class="normalModeMenu" v-else >
						<v-btn style="margin: 0"
							slot="activator" icon
						>
							<v-icon class="admin-drop-down-arrow">menu</v-icon>
						</v-btn>
						<v-list class="normalModeMenu">
							<v-list-tile v-for="(menuItem, i) in menuNonBetaMode" :key="i">
								<v-list-tile-title>
									<router-link :to="menuItem.url">
										{{ menuItem.title }}
									</router-link>
								</v-list-tile-title>
							</v-list-tile>
						</v-list>
					</v-menu> -->

					<router-link v-if="isKioskChannel" class="desktop-name" :to="getAdminHomePagePath">FoodShop</router-link>
					<router-link v-else class="desktop-name" :to="getAdminHomePagePath">{{routeTranslation("desktopName")}}</router-link>

					<router-link v-if="isKioskChannel" class="mobile-name" :to="getAdminHomePagePath">FoodShop</router-link>
					<router-link v-else class="mobile-name" :to="getAdminHomePagePath">{{routeTranslation("mobileName")}}</router-link>

				</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-toolbar-items v-if="showDepartments" class="departments-buttons">
					<department-button v-for="department in departments" :key="department.id" :department="department">
					</department-button>
				</v-toolbar-items>
				<v-spacer></v-spacer>
				<!-- Notifications panel start -->
				<template v-if="currentRoute === 'adminOrders'">
					<div class="text-xs-center admin-notifications-menu">
						<v-menu offset-y>
							<template v-slot:activator="{ on }" class="position-relative">
								<v-btn
									flat
									dark
									v-on="on"
									:disabled="ordersWithNewMessages.length === 0"
								>
									<v-icon color="white">mail</v-icon>
								</v-btn>
								<div class="messages-info-bubble"
									 :class="ordersWithNewMessages.length > 0 ? 'messages-info-bubble':'d-none'">
									<span>{{ ordersWithNewMessages.length }}</span>
								</div>
							</template>
							<v-list>
								<v-list-tile v-for="order in ordersWithNewMessages" v-bind:key="order.extId">
									<v-list-tile-title class="cursor-pointer">
										<div @click="setNewMessageFalse(order)">
											<span class="mr-2">Order id: <strong>{{ order.orderNumber }}</strong></span>
											<span>Pickup date: <strong>{{ order.pickupDate }}</strong></span>
										</div>
									</v-list-tile-title>
								</v-list-tile>
							</v-list>
						</v-menu>
					</div>
				</template>
				<v-spacer></v-spacer>
				<!-- Product monitoring menu start -->
				<template>
					<v-menu content-class="admin-dropdown-menu" v-if="isProductMonitoringActive" style="margin: 0;">
						<template v-slot:activator="{ on }">
							<v-btn
								v-on="on"
								flat small
								class="mobile-dropdown admin-menu-list"
							>
								<span class="desktop-name">Product monitoring</span>
								<v-icon class="shop-name-arrow" style="color: white; margin-left: 8px;">arrow_drop_down</v-icon>
							</v-btn>
						</template>
						<v-list>
							<v-list-tile
								v-for="(item, index) in pmItems"
								:key="index"
								@click="$router.push(item.url)"
							>
								<v-list-tile-title>{{ item.title }}</v-list-tile-title>
							</v-list-tile>
						</v-list>
					</v-menu>
				</template>
				<!-- Language menu start -->
				<v-menu content-class="admin-dropdown-menu admin-logout" v-if="isLocalizationEnabled" style="margin: 0;">
					<v-btn flat small class="mobile-dropdown admin-menu-list shop-name" slot="activator">
						<span class="shop-name-desktop">{{ getSelectedLanguage }}</span>
						<v-icon class="shop-name-arrow" style="color: white; margin-left: 8px;">arrow_drop_down</v-icon>
						<v-icon class="burger-menu-mobile" style="color: white; margin-left: 8px;">menu</v-icon>
					</v-btn>
					<v-list>
						<v-list-tile class="shop-name-mobile">
							<v-list-tile-title>
								<span>{{ selectedLanguage }}</span>
							</v-list-tile-title>
						</v-list-tile>
						<v-list-tile
							v-for="(language, locale) in languages"
							:key="locale"
							@click="clickedLanguage(locale, language)"
						>
							<v-list-tile-title>{{ language }}</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
				<v-menu content-class="admin-dropdown-menu admin-logout" v-if="adminDetails" style="margin: 0;"
					:min-width="customerCompensationInfo ? 320 : ''">
					<v-btn flat small class="mobile-dropdown admin-menu-list shop-name" slot="activator">
						<span class="shop-name-desktop">{{ adminDetails.shopName }}</span>
						<v-icon class="shop-name-arrow" style="color: white; margin-left: 8px;">arrow_drop_down</v-icon>
						<v-icon class="burger-menu-mobile" style="color: white; margin-left: 8px;">menu</v-icon>
					</v-btn>
					<v-list>
						<v-list-tile class="shop-name-mobile">
							<v-list-tile-title>
								<span>{{ adminDetails.shopName }}</span>
							</v-list-tile-title>
						</v-list-tile>
						<v-list-tile @click="shopSettings">
							<v-list-tile-title>
								<span>{{$t("admin.topMenuAdmin.shopSettings")}}</span>
							</v-list-tile-title>
						</v-list-tile>
						<v-list-tile v-if="customerCompensationInfo" class="v-list__tile--link">
							<v-dialog
								v-model="dialog"
								width="500"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-list-tile-title v-bind="attrs" v-on="on" class="cursor-pointer">
										<span>ANBEFALET KOMPENSERING TIL KUNDER</span>
									</v-list-tile-title>
								</template>

								<v-card>
									<v-card-title>
										<p class="headline">
											Har kunden haft en uheldig oplevelse med sin mad, anbefales nedenstående kompensationsformer
										</p>
										<p class="mb-0">(Disse benyttes også af kundeservice, hvis en kunde giver en dårlig anmeldelse på Trustpilot)</p>
									</v-card-title>

									<v-card-text class="pt-0">
										<ul>
											<li>
												<strong>Uheldigt tilfælde:</strong> Kunden tilbydes -50% på en ny ordre med det pågældende produkt
											</li>
											<li>
												<strong>Svært uheldigt tilfælde:</strong> Kunden tilbydes at få en identisk ordre gratis
											</li>
										</ul>
									</v-card-text>

									<v-divider></v-divider>

									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn
											color="primary"
											text
											@click="dialog = false"
										>
											OK
										</v-btn>
									</v-card-actions>
								</v-card>
							</v-dialog>
						</v-list-tile>
						<v-list-tile v-if="jwtToken" @click="logout">
							<v-list-tile-title>
								<span>{{$t("admin.topMenuAdmin.logout")}}</span>
							</v-list-tile-title>
						</v-list-tile>
					</v-list>
				</v-menu>
			</v-toolbar>
			<!-- Nikola 2017-09-18: We need this break as a hack against bad padding in prod - don't know what causes it. -->
			<br/>
			<product-order-count-dialog
				:modalComponentShown="productOrderCountDialog.opened"
				:closeCallback="productOrderCountDialog.closeCallback"
			/>
		</div>
	</div>
</template>

<script>
	import appConfig, {channelEnum} from "../../appconfig";
	import {mapGetters} from "vuex";
	import {
		ADMIN_REMOVE_JWT_TOKEN,
		SET_ADMIN_TOP_MENU_SHOWN_STATE
	} from "../../store/mutation-types";
	import DepartmentButton from "../Admin/DepartmentButton.vue";
	import ProductOrderCountDialog from "./Products/ProductOrderCountDialog";
	import routeMapper from "../../../src/router/routeMapper";
	import OrdersProvider from "../../providers/OrdersProvider";
	import {changeLanguage} from "../../helper/LocalizationHelper";
	import _ from "lodash";
	import {canAccessPageBasedOnPermission} from "../../helper/AdminBackofficeHelper";

	const {Formats: timeBoxFormats, timebox: timeBox} = appConfig.timeBoxImpl;
	const tenantConfig = appConfig.tenantConfig;

	export default {
		name: "TopMenuAdmin",
		data() {
			const self = this;
			return {
				tenantId: tenantConfig.tenantId,
				departments: [],
				displayMealCounterPage: false,
				customerCompensationInfo: false,
				productOrderCountDialog: {
					opened: false,
					closeCallback() {
						self.productOrderCountDialog.opened = false;
					}
				},
				selectedLanguage: "",
				offset: true,
				dialog: false,
				ordersWithNewMessages: [],
				useOverwrittenMenu: false,
				pmItems: [ {
					title: "Easter",
					url: "/admin/productMonitoring5/"
				}, {
					title: "Bager",
					url: "/admin/productMonitoring4/"
				}, {
					title: "Mortensaften",
					url: "/admin/productMonitoring2/"
				}, {
					title: "Juleaften",
					url: "/admin/productMonitoring3/"
				}, {
					title: "Nytårsmenu",
					url: "/admin/productMonitoring/"
				}]
			};
		},
		components: {
			DepartmentButton,
			ProductOrderCountDialog
		},
		async created() {
			this.departments = this.productCatalog.getDepartments();
			this.displayMealCounterPage = this.featureToggles.displayMealCounterPage;
			this.customerCompensationInfo = this.featureToggles.customerCompensationInfo;
			if (this.currentRoute === "adminOrders") {
				this.getOrdersWithNewMessages();
			}
			this.selectedLanguage = this.languages[this.lastLocaleAdmin];
			this.$store.dispatch("setNavMenuItems", this.menuBeta
				.flatMap(item => item)
				.flatMap(parent =>
					parent.children ?
						parent.children.map(child => ({icon: parent.icon, ...child})) :
						parent
				)
			);
		},
		computed: {
			...mapGetters(["adminDetails", "jwtToken", "productCatalog", "productEditingState", "envPrefix", "featureToggles", "languages", "lastLocaleAdmin","featureToggles", "isNavBarOpen"]),
			isLocalizationEnabled() {
				return typeof this.featureToggles.dynamicLocalization !== "undefined"
					? this.featureToggles.dynamicLocalization
					: appConfig.tenantConfig.enableDynamicLocalization;
			},
			getSelectedLanguage(){
				this.selectedLanguage = this.languages[this.lastLocaleAdmin];
				return this.selectedLanguage;
			},
			getAdminHomePagePath() {
				return "/admin/orders";
			},
			showDepartments() {
				return !!(this.$route.name === routeMapper.routeNames.adminOrders || this.$route.name === routeMapper.routeNames.adminSingleOrder);
			},
			showAdminMenu() {
				const self = this;
				if (self.envPrefix === "p" || self.envPrefix === "o") {
					if(appConfig.isBetaMode()){
						self.useOverwrittenMenu = false;
						return true;
					} else if (!appConfig.isBetaMode() && self.overwrittenMenu.length > 0){
						self.useOverwrittenMenu = true;
						return true;
					} else {
						self.useOverwrittenMenu = false;
						return false;
					}
				} else {
					self.useOverwrittenMenu = false;
					return true;
				}
			},
			menu() {
				const self = this;
				const menuItems = [
					{
						title: "Capacity prototype",
						url: "/admin/capacityPrototype"
					},
					{
						title: "Capacity rules",
						url: "/admin/capacityRulesNew"
					},
					{
						title: "Catalog pages",
						url: "/admin/catalogPages"
					},
					{
						title: "Catalog pages UI",
						url: "/admin/catalogPagesUi"
					},
					{
						title: "Developer support",
						url: "/admin/devsupport"
					},
					{
						title: "Enriched product catalogs",
						url: "/admin/enrichedCatalog"
					},
					{
						title: "Export logs",
						url: "/admin/export"
					},
					{
						title: "Feature toggle",
						url: "/admin/featureToggle"
					},
					// {
					// 	title: "Ingredients",
					// 	url: "/admin/ingredients"
					// },
					{
						title: "Localization settings",
						url: "/admin/localizationSettings"
					},
					// marketing cards should be here
					{
						title: "Obsolete",
						url: "/admin/settings"
					},
					{
						title: "Opening hours per shop",
						url: "/admin/timePicker/"
					},
					{
						title: "Order Control Panel ",
						url: "/admin/ordercontrolpanel/"
					},
					{
						title: "Pickup datetime rules",
						url: "/admin/pickupRules"
					},
					{
						title: "Price rules",
						url: "/admin/priceRules"
					},
					{
						title: "Cross-sell rules",
						url: "/admin/crossSellRules"
					},
					{
						title: "Products",
						url: "/admin/products"
					},
					{
						title: "Product ingredients",
						url: "/admin/productsIngredients"
					},
					{
						title: "Product monitoring - Bager",
						url: "/admin/productMonitoring4/",
						showOnTenant: [2, 3]
					},
					{
						title: "Product monitoring - Juleaften",
						url: "/admin/productMonitoring3/",
						showOnTenant: [2, 3]
					},
					{
						title: "Product monitoring - Nytårsmenu",
						url: "/admin/productMonitoring/",
						showOnTenant: [2, 3]
					},
					{
						title: "Product monitoring - Mortensaften",
						url: "/admin/productMonitoring2/",
						showOnTenant: [2, 3]
					},
					{
						title: "Product statistics",
						url: "/admin/productstatistics"
					},
					//making this unaccessible via admin because the component isn't done
					//it will be finished after foodshop team is back from sunset
					//{
					//	title: "Generate Orders",
					//	url: "/admin/orders/generateOrders"
					//},
					{
						title: "Punch-card rules",
						url: "/admin/punchCardRules"
					},
					{
						title: "Quick ordering",
						url: "/admin/newOrder",
						bothMenuAppearance: true
					},
					{
						title: "Shops",
						url: "/admin/shops/"
					},
					{
						title: "Shop Info",
						url: "/admin/shopInfo/"
					},
					{
						title: "Shop Settings",
						url: "/admin/shopSettings/",
						bothMenuAppearance: true
					},
					{
						title: "Subscriptions fraud protection",
						url: "/admin/subscriptionsFraudProtection"
					},
					{
						title: "Synchronizations",
						url: "/admin/synchronizations"
					},
					{
						title: "Tenant Settings",
						url: "/admin/tenantSettings"
					},
					{
						title: "Vouchers",
						url: "/admin/voucherRules"
					},
					{
						title: "Terms & Conditions",
						url: "/admin/termsAndConditions"
					},
					{
						title: "S3 Cloud",
						url: "/admin/s3Cloud"
					},
					{
						title: "Product Badges",
						url: "/admin/productBadges"
					},
					{
						title: "Scheduled Tasks Manager",
						url: "/admin/scheduledTasksManager"
					},
					{
						title: "Shop Settings",
						url: `/admin/gbo/shopSettings`
					},
					{
						title: "Statistics",
						url: "/admin/gbo/statistics"
					},
					{
						title: "Product Availability",
						url: `/admin/gbo/productAvailability`
					},
					{
						title: "Audit log",
						url: `/admin/gbo/auditLog`
					}
				];
				if (self.$store.getters.featureToggles.showTheBackofficeNewLandingPage) {
					menuItems.push({
						title: "Orders",
						url: "/admin/orders"
					});
				}
				if(self.displayMealCounterPage) {
					menuItems.push({
						title: "Meal counter page",
						url: "/admin/productCounterOverview"
					});
				}
				if(tenantConfig.disabledAdminMenuPaths){
					tenantConfig.disabledAdminMenuPaths.forEach(override => {
						const index = menuItems.findIndex(item => item.url === `/admin/${override}`);
						if(index > -1){
							menuItems.splice(index, 1);
						}
					});
				}
				if(self.featureToggles.marketingCards){
					menuItems.push(
						{
							title: "Marketing cards",
							url: "/admin/marketingCards"
						},
						{
							title: "Target groups",
							url: "/admin/targetGroups"
						}
					);
				}
				if(self.featureToggles.globalVersions && self.featureToggles.gbo){
					menuItems.push(
						{
							title: "Global Versions GBO",
							url: "/admin/gbo/globalVersions"
						}
					);
				}

				if(self.featureToggles.gbo){
					menuItems.push(
						{
							title: "Product Groups GBO",
							url: "/admin/gbo/productGroups"
						},
						{
							title: "Admin users GBO",
							url: "/admin/gbo/adminUsers"
						},
						{
							title: "Vouchers GBO",
							url: "/admin/gbo/voucherRules"
						},
						{
							title: "Cross-sell rules GBO",
							url: "/admin/gbo/crossSellRules"
						},
						{
							title: "Price rules GBO",
							url: "/admin/gbo/priceRules"
						},
						{
							title: "Capacity prototypes GBO",
							url: "/admin/gbo/capacityPrototype"
						},
						{
							title: "Pickup datetime rules GBO",
							url: "/admin/gbo/pickupRules"
						},
						{
							title: "Terms & Conditions GBO",
							url: "/admin/gbo/termsAndConditions"
						},
						{
							title: "Statistics GBO",
							url: "/admin/gbo/statistics"
						},
						{
							title: "Order Control Panel GBO",
							url: "/admin/gbo/orderControlPanel"
						},
						{
							title: "Feature toggle GBO",
							url: "/admin/gbo/featureToggle"
						},
						{
							title: "Tenant Settings GBO",
							url: "/admin/gbo/tenantSettings"
						}
					);
				}

				menuItems.sort((firstItem, secondItem) => firstItem.title > secondItem.title ? 1 : (secondItem.title > firstItem.title ? -1 : 0));

				return menuItems
					.filter(el=>!el.showOnTenant || el.showOnTenant.includes(tenantConfig.tenantId)) // filter by hardcoded tenant filtering
					.filter((el) => {
						const routeEl = self.$router.match(el.url);
						const pagePermission = _.get(routeEl, "meta.pagePermission");
						if (pagePermission) {
							// if page has meta pagePermission check if logged user has access to it
							return canAccessPageBasedOnPermission(pagePermission, self.$store);
						}

						return true;
					});
			},
			overwrittenMenu(){
				if(!tenantConfig.adminMenuOverride) {
					return [];
				}
				return this.menu
					.filter((elem) => tenantConfig
						.adminMenuOverride
						.some((override) => elem.url === `/admin/${override}` || elem.url === `/admin/${override}/`)
					);
			},
			menuNonBetaMode(){
				return this.menu.filter( e => e.bothMenuAppearance);
			},
			productMonitoringShortcutDisplayed() {
				return !!((this.$route.name === routeMapper.routeNames.adminOrders && tenantConfig.tenantId === 3) || (this.$route.name === routeMapper.routeNames.adminOrders && tenantConfig.tenantId === 2 ));
			},
			currentRoute() {
				return this.$route.name;
			},
			betaMode() {
				return appConfig.isBetaMode();
			},
			isKioskChannel() {
				return appConfig.channelAlias() === channelEnum.kiosk;
			},
			menuBeta() {
				const self = this;
				let menuItems = [
					[
						{
							title: "Home",
							icon: "home",
							url: "/admin/",
							isHomeItem: true
						}
					],
					[
						{
							title: "Products",
							icon: "inventory_2",
							children: [
								{
									title: "Catalog pages",
									url: "/admin/catalogPages",
									pagePermission: "catalogPagesOverviewPagePermission"
								},
								{
									title: "Catalog pages UI",
									url: "/admin/catalogPagesUI",
									pagePermission: "catalogPagesUIOverviewPagePermission"
								},
								{
									title: "Products",
									url: "/admin/products",
									pagePermission: "productOverviewPagePermission"
								},
								{
									title: "Product ingredients",
									url: "/admin/productsIngredients",
									pagePermission: "createProductIngredientsPagePermission"
								},
								{
									title: "Enriched product catalogs",
									url: "/admin/enrichedCatalog",
									pagePermission: "enrichedProductCatalogsPagePermission"
								},
								{
									title: "Export logs",
									url: "/admin/export",
									pagePermission: "exportPagePermission"
								}
							]
						},
						{
							title: "Shops",
							icon: "shopping_cart",
							children: [
								{
									title: "Shops",
									url: "/admin/shops/",
									pagePermission: "shopsSettingsPagePermission"
								},
								{
									title: "Opening hours per shop",
									url: "/admin/timePicker/",
									pagePermission: "timePickerPagePermission"
								},
								{
									title: "Quick ordering",
									url: "/admin/newOrder",
									bothMenuAppearance: true,
									pagePermission: "newOrderPagePermission"
								},
								{
									title: "Localization settings",
									url: "/admin/localizationSettings",
									pagePermission: "localizationSettingsPagePermission"
								},
								{
									title: "Shop Info",
									url: "/admin/shopInfo/",
									pagePermission: "shopInfoPagePermission"
								}
							]
						},
						{
							title: "Rules",
							icon: "grading",
							children: [
								{
									title: "Pickup datetime rules",
									url: "/admin/pickupRules",
									pagePermission: "pickupDateTimeRulesPagePermission"
								},
								{
									title: "Price rules",
									url: "/admin/priceRules",
									pagePermission: "priceRulesPagePermission"
								},
								{
									title: "Punch-card rules",
									url: "/admin/punchCardRules",
									pagePermission: "punchCardRulesPagePermission"
								},
								{
									title: "Cross-sell rules",
									url: "/admin/crossSellRules",
									pagePermission: "crossSellRulesPagePermission"
								},
								{
									title: "Vouchers",
									url: "/admin/voucherRules",
									pagePermission: "vouchersPagePermission"
								},
								{
									title: "Capacity prototype",
									url: "/admin/capacityPrototype",
									pagePermission: "capacityRulesPrototypePagePermission"
								},
								{
									title: "Capacity rules",
									url: "/admin/capacityRulesNew",
									pagePermission: "capacityRulesPagePermission"
								},
								{
									title: "Obsolete",
									url: "/admin/settings",
									pagePermission: "settingsPagePermission"
								},
								{
									title: "Terms & Conditions",
									url: "/admin/termsAndConditions",
									pagePermission: "termsAndConditionsPagePermission"
								}
							]
						}
					],
					[
						{
							title: "Protection",
							icon: "verified_user",
							children: [
								{
									title: "Subscriptions fraud protection",
									url: "/admin/subscriptionsFraudProtection",
									pagePermission: "subscriptionsFraudProtectionPagePermission"
								}
							]
						},
						{
							title: "Control Panel",
							icon: "settings",
							children: [
								{
									title: "Order Control Panel ",
									url: "/admin/ordercontrolpanel/",
									pagePermission: "orderControlPanelPagePermission"
								},
								{
									title: "Developer support",
									url: "/admin/devsupport",
									pagePermission: "devSupportPagePermission"
								},
								{
									title: "Tenant Settings",
									url: "/admin/tenantSettings",
									pagePermission: "tenantSettingsPagePermission"
								},
								{
									title: "Feature toggle",
									url: "/admin/featureToggle",
									pagePermission: "featureTogglePagePagePermission"
								},
								{
									title: "Synchronizations",
									url: "/admin/synchronizations",
									pagePermission: "synchronizationsPagePermission"
								}
							]
						},
						{
							title: "Statistics",
							icon: "analytics",
							children: [
								{
									title: "Statistics",
									url: "/admin/statistics",
									pagePermission: "orderStatisticsPagePermission"
								},
								{
									title: "Order statistics",
									url: "/admin/orderstatistics"
								},
								{
									title: "Product statistics",
									url: "/admin/productstatistics",
									pagePermission: "productStatisticsPagePermission"
								},
								{
									title: "Product monitoring - Bager",
									url: "/admin/productMonitoring4/",
									pagePermission: "productMonitoring4PagePermission",
									showOnTenant: [2, 3]
								},
								{
									title: "Product monitoring - Juleaften",
									url: "/admin/productMonitoring3/",
									pagePermission: "productMonitoring3PagePermission",
									showOnTenant: [2, 3]
								},
								{
									title: "Product monitoring - Nytårsmenu",
									url: "/admin/productMonitoring/",
									pagePermission: "productMonitoringPagePermission",
									showOnTenant: [2, 3]
								},
								{
									title: "Product monitoring - Mortensaften",
									url: "/admin/productMonitoring2/",
									pagePermission: "productMonitoring2PagePermission",
									showOnTenant: [2, 3]
								},
								...(self.displayMealCounterPage ?
									[{
										title: "Meal counter page",
										url: "/admin/productCounterOverview",
										pagePermission: "productCounterOverviewPagePermission"
									}] :
									[])
							]
						}
					]
					// {
					// 	title: "Ingredients",
					// 	url: "/admin/ingredients"
					// },

					//making this unaccessible via admin because the component isn't done
					//it will be finished after foodshop team is back from sunset
					//{
					//	title: "Generate Orders",
					//	url: "/admin/orders/generateOrders"
					//},
					// {
					// 	title: "S3 Cloud",
					// 	url: "/admin/s3Cloud"
					// }
				];

				// Check if item can be shown on tenant
				menuItems = menuItems.map(section => section.map(
					cat => {
						if (cat.children && cat.children.length > 0) {
							cat.children = cat.children.filter(
								el => el.showOnTenant ?
									el.showOnTenant.includes(tenantConfig.tenantId) : true
							);
							return cat;
						} else {
							return cat;
						}
					}));

				// Check if item is included in tenantConfig.adminMenuOverride
				if (self.useOverwrittenMenu && tenantConfig.adminMenuOverride) {
					menuItems = menuItems.map(section => section.map(
						cat => {
							if (cat.children && cat.children.length > 0) {
								cat.children = cat.children.filter(
									el => tenantConfig.adminMenuOverride.find(override => el.url === `/admin/${override}` || el.url === `/admin/${override}/`)
								);
								return cat;
							} else {
								return cat;
							}
						}));
				}

				// Check if item is disabled on the tenant
				if (tenantConfig.disabledAdminMenuPaths) {
					menuItems = menuItems.map(section => {
						const refactoredSection = section.map(cat => {
							if (cat.children && cat.children.length > 0) {
								cat.children = cat.children.filter(
									el => !tenantConfig.disabledAdminMenuPaths.find(override => el.url === `/admin/${override}` || el.url === `/admin/${override}/`)
								);
								return cat;
							} else {
								return cat;
							}
						});
						return refactoredSection;
					}
					);
				}

				const addToCategory = (categoryTitle, ...routeObjects) => {
					menuItems.forEach(section => {
						const category = section.find(category => category.title === categoryTitle);
						if (category) {
							category.children.push(...routeObjects);
						}
					});
				};

				if (self.featureToggles.marketingCards) {
					addToCategory("Control Panel", {
						title: "Marketing cards",
						url: "/admin/marketingCards",
						pagePermission: "marketingCardsPagePermission"
					},
					{
						title: "Target groups",
						url: "/admin/targetGroups",
						pagePermission: "targetingGroupsPagePermission"
					});
				}
				if(self.featureToggles.globalVersions){
					addToCategory("Control Panel", {
						title: "Global Versions GBO",
						url: "/admin/gbo/globalVersions",
						pagePermission: "globalVersionsGboPagePermission"
					});
				}
				return menuItems.filter(el => !el.showOnTenant || el.showOnTenant.includes(tenantConfig.tenantId));
			},
			isProductMonitoringActive() {
				return this.featureToggles.showProductMonitoringMenu;
			}
		},
		methods: {
			isGboAdmin() {
				// NOTE: there is toggle button which is shown based on the commented condition bellow
				// it will be used at the later point
				return false;
			},
			toggleTopMenu() {
				this.$store.commit(SET_ADMIN_TOP_MENU_SHOWN_STATE);
			},
			async logout() {
				localStorage.removeItem("admin-user");
				this.$store.commit(ADMIN_REMOVE_JWT_TOKEN);
				if(appConfig.gboAppUrl()) {
					await this.logoutGboApp();
				}
				this.$router.push("/admin/login");
			},
			shopSettings() {
				this.$router.push("/admin/shopSettings");
			},
			async setNewMessageFalse(order) {
				const self = this;
				if (order.newOrderMessageFlag) {
					await self.$store.dispatch("setOrderMessageAsRead", {
						orderId: order.extId
					});
					self.getOrdersWithNewMessages();
				}
				this.$router.push(`/admin/orders/${order.extId}`);
			},
			getOrdersWithNewMessages() {
				OrdersProvider.findAllWithNewMessages(timeBox.now().format(timeBoxFormats.YYYY_MM_DD).exec())
					.then(result => {
						this.ordersWithNewMessages = result.data.data;
					});
			},
			async clickedLanguage(locale, language) {
				const self = this;
				await changeLanguage({ locale, vuexStore: self.$store, adminRoute: true });
				self.selectedLanguage = language;
			},
			routeTranslation(translationType){
				const shouldDisable = tenantConfig.isFeatureDisabled("customTranslations", translationType);
				return shouldDisable
					? this.$t("admin.topMenuAdmin.adminPanel")
					: this.$t(`admin.topMenuAdmin.${translationType}`);
			},
			toggleNavBar() {
				if (this.isNavBarOpen)
					this.$store.dispatch("closeNavBar");
				else
					this.$store.dispatch("openNavBar");
			},
			async logoutGboApp() {
				const self = this;
				await this.$store.dispatch("setIsInitGboAppValue", true);
				const iframeGboApp = await self.loadGboAppIframe();
				iframeGboApp.contentWindow.postMessage({
					type: "logout",
					tenantId: appConfig.tenantId
				}, appConfig.gboAppUrl());
			},
			async loadGboAppIframe() {
				return new Promise((resolve, reject) => {
					const iframeGboApp = document.createElement("iframe");
					iframeGboApp.setAttribute("src", appConfig.gboAppUrl());
					document.body.appendChild(iframeGboApp);
					iframeGboApp.onload = () => resolve(iframeGboApp);
					iframeGboApp.onerror = reject;
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
	.disable {
		// Note: pointer-events not supported by IE10 and under
		pointer-events: none;
		opacity: 0.4;
	}

	// Disable scrolling on child elements
	.disable div,
	.disable textarea {
		overflow: hidden;
	}

	.admin-logo.v-toolbar__title {
		overflow: visible !important;
		margin-left: 0 !important;

		a {
			text-decoration: none;
			color: #fff;
			font-size: 20px;
			font-weight: bold;
			position: relative;
			top: 2px;
		}
	}

	div /deep/ .v-toolbar__content {
		padding: 0 16px;
		padding-bottom: 10px;
		margin: 0 auto;
		min-height: 77px;
		height: auto !important;
		flex-wrap: wrap;
		justify-content: flex-end;

		.admin-burger {
			margin: 0;
		}

		.v-text-field__details {
			display: none !important;
		}

		.admin-store-list {
			font-size: 16px;
			font-weight: bold;
			padding: 0;
			text-decoration: none;

			.input-group__selections__comma {
				color: #fff;
			}

			.material-icons.v-icon.input-group__append-icon {
				color: #fff;
			}
		}
		.admin-menu {
			background-color: #002A46;
		}
		.admin-menu-list {
			text-decoration: none;
			color: #fff;
			font-weight: bold;
			text-transform: unset;
			margin: 0 4px 0 30px !important;
			font-size: 14px;

			.v-btn__content {
				padding: 0 4px 0 8px;
			}

			.v-toolbar__title {
				font-weight: bold;
				opacity: 0.39;
				line-height: 17px;
				font-size: 16px;
				margin-left: 0;

				&:last-child {
					margin-right: 0;
				}

				&.active {
					font-weight: bold;
					opacity: 1;

					b {
						border-bottom: 2px solid #7fceef;
					}
				}

				span {
					color: #000000;
					background-color: #f6a623;
					display: inline-block;
					width: 24px;
					height: 24px;
					border-radius: 50%;
					text-align: center;
					line-height: 24px;
					font-size: 14px;
					margin-left: 5px;
				}
			}
		}
	}
	.top-menu-admin {
		height: 77px;
		position: sticky;
		z-index: 30;
	}
	.v-toolbar__items {
		padding: 0;
		align-items: center;
	}

	.v-menu__content li {
		border-bottom: solid 1px rgba(0, 0, 0, 0.12);
		z-index: 1000;
	}

	.v-list__tile__title span, .v-list__tile__title a {
		color: rgba(0, 0, 0, 0.87);
		font-size: 15px;
		text-decoration: none;
	}

	.admin-drop-down-arrow {
		color: #ffffff !important;
		font-size: 24px !important;
	}
	@media (min-width: 870px){
		.burger-menu-mobile, .mobile-name, .shop-name-mobile {
			display: none;
		}
	}
	@media (max-width: 870px){
		//.top-menu-admin {
		//	height: 56px;
		//}
		div /deep/ .v-toolbar__content {
			height: 56px !important;
		}
		.shop-name-arrow, .shop-name-desktop, .desktop-name {
			display: none;
		}
		.mobile-dropdown {
			position: absolute;
			top: 5px;
			right: 0;
		}
	}
	.admin-dropdown{
		max-height: 800px;
		overflow-x: hidden;
        overflow-y: auto;
		left: 0 !important;
	}
	.normalModeMenu{
		min-height: 50px;
		overflow-x: hidden;
        overflow-y: auto;
		left: 0 !important;
	}

	.admin-top-menu-toggle {
		position: absolute;
		top: 0;
		z-index: 9;
		left: calc(50% - 15px);
		width: 30px;
		background-color: #003355;
		border: 1px solid #003959;
	}

	@media screen and (max-width: 600px) {
		.monitoring-buttons {
			margin-top: 8px;
		}
	}

	@media screen and (max-width: 380px) {
		.monitoring-buttons {
			margin-top: 4px;

			a {
				font-size: 10px;
				padding: 3px 8px;
			}
		}
	}

</style>
/* IE FIXES */
<style lang="scss" scoped>

	@media all and (-ms-high-contrast: none) {
		.foo {
			color: green
		}
		/* IE10 */
		*::-ms-backdrop, .v-toolbar__title /deep/ .admin-store-list .v-text-field__slot {
			-ms-flex: 0 1 auto;
			flex: 0 1 auto;
		}
		/* IE11 */
	}
</style>
